export default __webpack_public_path__ + "static/media/scanQRIcon.2a704713.svg";